import { Types } from '@antv/g2';

export type Legend = false | Types.LegendCfg;
